<template>
    <div class="actions">
        <span class="action"> 
            <svg 
                class="icon icon_weight" 
                :class="{
                    'icon_weight_active': isCompared
                }"
                viewBox="0 0 24 24"
                v-if="compare" 
                width="20px" 
                height="20px" 
                fill="grey"
                id="icon-compare"
                @click="compareAction"
                :ref="`icon-compare_${id}`"
            >
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 7.15088L11 15.7064V16.0001C11 17.23 10.7256 18.7067 9.87944 19.9053C8.99594 21.1568 7.55968 22.0001 5.5 22.0001C3.44033 22.0001 2.00406 21.1568 1.12056 19.9053C0.27439 18.7067 0 17.23 0 16.0001V15.7064L5.5 7.15088ZM2.08102 17.0001C2.1881 17.6425 2.40512 18.257 2.75444 18.7518C3.24594 19.4481 4.05967 20.0001 5.5 20.0001C6.94033 20.0001 7.75406 19.4481 8.24556 18.7518C8.59488 18.257 8.8119 17.6425 8.91898 17.0001H2.08102ZM8.16833 15.0001H2.83167L5.5 10.8494L8.16833 15.0001Z"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.5 7.15088L24 15.7064V16.0001C24 17.23 23.7256 18.7067 22.8794 19.9053C21.9959 21.1568 20.5597 22.0001 18.5 22.0001C16.4403 22.0001 15.0041 21.1568 14.1206 19.9053C13.2744 18.7067 13 17.23 13 16.0001V15.7064L18.5 7.15088ZM15.081 17.0001C15.1881 17.6425 15.4051 18.257 15.7544 18.7518C16.2459 19.4481 17.0597 20.0001 18.5 20.0001C19.9403 20.0001 20.7541 19.4481 21.2456 18.7518C21.5949 18.257 21.8119 17.6425 21.919 17.0001H15.081ZM21.1683 15.0001H15.8317L18.5 10.8494L21.1683 15.0001Z"></path>
                <path d="M12 2C12.7403 2 13.3866 2.4022 13.7324 3H21V5H13.7324C13.3866 5.5978 12.7403 6 12 6C11.2597 6 10.6134 5.5978 10.2676 5H3V3H10.2676C10.6134 2.4022 11.2597 2 12 2Z"></path>
            </svg>
        </span>
 
        <span 
            class="action" 
            v-if="like"
            @click="likeAction"
        >
            <svg 
                class="icon icon_like"
                viewBox="0 -28 512.001 512"
                fill="grey" 
                width="20px"
                xmlns="http://www.w3.org/2000/svg"
                :class="{
                    'icon_like_active': isFavs
                }"
                :ref="`icon_like_${id}`"
            >
                <path d="m256 455.515625c-7.289062 0-14.316406-2.640625-19.792969-7.4375-20.683593-18.085937-40.625-35.082031-58.21875-50.074219l-.089843-.078125c-51.582032-43.957031-96.125-81.917969-127.117188-119.3125-34.644531-41.804687-50.78125-81.441406-50.78125-124.742187 0-42.070313 14.425781-80.882813 40.617188-109.292969 26.503906-28.746094 62.871093-44.578125 102.414062-44.578125 29.554688 0 56.621094 9.34375 80.445312 27.769531 12.023438 9.300781 22.921876 20.683594 32.523438 33.960938 9.605469-13.277344 20.5-24.660157 32.527344-33.960938 23.824218-18.425781 50.890625-27.769531 80.445312-27.769531 39.539063 0 75.910156 15.832031 102.414063 44.578125 26.191406 28.410156 40.613281 67.222656 40.613281 109.292969 0 43.300781-16.132812 82.9375-50.777344 124.738281-30.992187 37.398437-75.53125 75.355469-127.105468 119.308594-17.625 15.015625-37.597657 32.039062-58.328126 50.167969-5.472656 4.789062-12.503906 7.429687-19.789062 7.429687zm-112.96875-425.523437c-31.066406 0-59.605469 12.398437-80.367188 34.914062-21.070312 22.855469-32.675781 54.449219-32.675781 88.964844 0 36.417968 13.535157 68.988281 43.882813 105.605468 29.332031 35.394532 72.960937 72.574219 123.476562 115.625l.09375.078126c17.660156 15.050781 37.679688 32.113281 58.515625 50.332031 20.960938-18.253907 41.011719-35.34375 58.707031-50.417969 50.511719-43.050781 94.136719-80.222656 123.46875-115.617188 30.34375-36.617187 43.878907-69.1875 43.878907-105.605468 0-34.515625-11.605469-66.109375-32.675781-88.964844-20.757813-22.515625-49.300782-34.914062-80.363282-34.914062-22.757812 0-43.652344 7.234374-62.101562 21.5-16.441406 12.71875-27.894532 28.796874-34.609375 40.046874-3.453125 5.785157-9.53125 9.238282-16.261719 9.238282s-12.808594-3.453125-16.261719-9.238282c-6.710937-11.25-18.164062-27.328124-34.609375-40.046874-18.449218-14.265626-39.34375-21.5-62.097656-21.5zm0 0"></path>
            </svg>
        </span> 
        <!-- <span class="action" v-if="bin">
            <svg class="icon icon_bin" height="20px" viewBox="-40 0 427 427.00131" fill="grey" width="20px" xmlns="http://www.w3.org/2000/svg"><path d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0"/><path d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/></svg>
        </span> -->
    </div> 
</template>

<script>
import {mapActions} from 'vuex';

export default {
    name: 'main-actions',
    props: {
        like: {
            required: false,
            default: true
        },
        compare: {
            required: false,
            default: true
        },
        bin: {
            required: false,
            default: true
        },
        isCompared: {
            required: false,
            default: false
        },
        isFavs: {
            required: false,
            default: false
        },
        id: {
            required: true,
        }
    },
    methods: {
        ...mapActions({
            removeComparing: 'comparing/remove',
            addComparing: 'comparing/add',
            getComparing: 'comparing/get',
            addFavs: 'favorites/add',
            removeFavs: 'favorites/remove',
            getFavs: 'favorites/get'
        }),
        async likeAction() { 
            const activeClass = 'icon_like_active';
            if(!this.$refs.hasOwnProperty(`icon_like_${this.id}`)) {
                return;
            }
            
            const element = this.$refs[`icon_like_${this.id}`];
  
            if(this.isFavs && element.classList.contains(activeClass)) 
                await this.removeFavs(this.id);
            else
                await this.addFavs(this.id);
            
            if(element.classList.contains(activeClass)) 
                element.classList.remove(activeClass); 
            else 
                element.classList.add(activeClass);
                
            await this.getFavs();
        },
        async compareAction() {
            const activeClass = 'icon_weight_active';
            if(!this.$refs.hasOwnProperty(`icon-compare_${this.id}`)) {
                return;
            }
            
            const element = this.$refs[`icon-compare_${this.id}`];
 
            if(element.classList.contains(activeClass)) 
                await this.removeComparing(this.id);
            else 
                await this.addComparing(this.id);
              

            if(element.classList.contains(activeClass)) 
                element.classList.remove(activeClass); 
            else 
                element.classList.add(activeClass);

            await this.getComparing();
        }
    }
}
</script>

<style lang="scss" scoped>
.action {
    margin-left: 10px;
}

.icon {  
    cursor: pointer;

    path {
        transition: all .3s ease-in;
    } 

    &_weight {  
        &:hover path {
            fill: gold;
        } 

        &_active {
            fill: gold;
        }
    }

    &_like { 
        &:hover path {
            fill: red;
        } 

        &_active {
            fill: red;
        }
    }   

    &_bin { 
        &:hover path {
            fill: #262538;
        } 
    }
}
 
</style>